import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BORDER_GRAY, DARK_GRAY } from 'constants/colors';
export default makeStyles(theme => {
  return createStyles({
    profileItem: {
      display: 'flex',
      flexDirection: 'column',
      margin: theme.spacing(2, 0),
      float: 'left',
      // this is for margins not to overlap
      clear: 'both' // this is for margins not to overlap
    },
    profileInfoItem: {
      margin: theme.spacing(0.5, 0)
    },
    profileValue: {
      wordBreak: 'break-word',
      marginRight: theme.spacing(1)
    },
    profileRow: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'flex-end'
    },
    actionButton: {
      margin: theme.spacing(2, 1, 2, 0)
    },
    accessRow: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginTop: theme.spacing(1),
      borderBottom: `1px solid ${BORDER_GRAY}`,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    dialog: {
      width: '500px',
      maxWidth: '100%'
    },
    dialogTitle: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    closeIcon: {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    submitButton: {
      margin: theme.spacing(1, 2, 3, 0)
    },
    textField: {
      margin: `${theme.spacing(0.5)}px 0 ${theme.spacing(3)}px 0`
    },
    emailInfo: {
      marginBottom: theme.spacing(3)
    },
    standardAddress: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(2, 0, 0, 0),
      color: DARK_GRAY
    },
    addPrivilege: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      border: `1px solid ${BORDER_GRAY}`,
      padding: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    dialogContent: {
      padding: theme.spacing(1)
    },
    mb2: {
      marginBottom: theme.spacing(2)
    },
    mt2: {
      marginTop: theme.spacing(2)
    }
  });
});